import { InventoryTypePlaceholderPage } from "../inventory-placeholder";

export const ClinicalFecalPage = () => {
  return <InventoryTypePlaceholderPage title="Clinical Fecal" />;
};
